export default [
	{
		path: '/pay/main/:id',
		name: 'PayMain',
		component: () => import('@/views/pay/main.vue'),
		meta: { title: '收银台' }
	}
]
